import { Navigate } from 'react-router-dom';

// routes declaration
export const supportRoute = {
  component: Navigate,
  path: '/',

  replace: true,
  to: '/support',
  needsAuth: true,
};
